import type { CreateCexDataDefaultParameters } from '../../types'
import { createCexData } from '../../utils/createCexData'
import { fetchWithdrawalHistories } from './fetchData'
import { parseWithdrawalHistoriesToActions } from './parseToActions'
import { parseWithdrawalHistoriesToSources } from './parseToSources'
import type { Withdrawal } from './schema'

const limit = 500

export const createKucoinWithdrawalHistoryData = async (
  parameters: Omit<CreateCexDataDefaultParameters, 'limit' | 'desc'>,
) =>
  createCexData<Withdrawal>({
    ...parameters,
    limit,
    desc: true,
    fetchAllData: async (parameters) => {
      if (parameters.password === undefined) {
        throw new Error('password is required')
      }
      const data = await fetchWithdrawalHistories({
        ...parameters,
        password: parameters.password,
        limit,
      })

      // sort
      const sortedData = data.toSorted((a, b) => a.createdAt - b.createdAt)
      return {
        data: sortedData,
        from: sortedData.length > 0 ? sortedData[0].createdAt : undefined,
        to:
          sortedData.length > 0
            ? sortedData[sortedData.length - 1].createdAt
            : undefined,
      }
    },
    parseToActions: parseWithdrawalHistoriesToActions,
    parseToAccountIds: () => [],
    parseToSources: parseWithdrawalHistoriesToSources,
  })
